import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "../assets/images/logo.png";
import { navbarItems } from "../config/option";
import { useDispatch, useSelector } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import { getNotificationNum2 } from "../function/functions";

const Navbar = () => {
  const { profileDetails } = useSelector((state) => state.webUtilities);
  const [total_notification, settotal_notification] = useState(0);
  const location = useLocation();
  const dispatch = useDispatch();

  const getData = async () => {
    try {
      const result = await getNotificationNum2();
      settotal_notification(result.length);
    } catch (error) {
      console.log(error);
    }
  };

  // get base_url
  const { protocol, hostname, port } = window.location;
  const portPart = port ? `:${port}` : ""; // Include port if it exists
  const fullURL = `${protocol}//${hostname}${portPart}`;

  const [activeMenuLocation, setActiveMenuLocation] = useState(
    location.pathname
  );
  const navRef = useRef(null);

  const handleChangeSidebar = async (menu) => {
    await dispatch(setDrawerActiveMenu(menu));
    await dispatch(setIsDrawerActive(true));
  };
  useEffect(() => {
    getData();

    const handleScroll = () => {
      if (window.scrollY >= 20) {
        navRef.current.classList.add("shadow-xl");
      } else {
        navRef.current.classList.remove("shadow-xl");
      }
      secureLocalStorage.setItem("sp", window.scrollY);
    };
    window.addEventListener("scroll", handleScroll);
    // Retrieve scroll position from secureLocalStorage on page load
    const sp = secureLocalStorage.getItem("sp");
    if (sp) {
      window.scrollTo(0, parseInt(sp));
    }
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount

  return (
    <nav
      id="navbar"
      ref={navRef}
      className="items-center border-0 fixed top-0 z-30"
    >
      <div className="sm:ml-8 ml-0">
        <Link to="/">
          <img
            loading="lazy"
            src={Logo}
            alt="logo"
            className="w-32 h-auto"
            height={"24px"}
            width={"80px"}
          />
        </Link>
      </div>
      <div>
        {/* Menu for dashboard only */}
        <div className="menu-items gap-x-4">
          {navbarItems.map((item, index) => (
            <Link
              className={`font-medium text-sm px-1.5 py-1 ${
                activeMenuLocation === item.link ||
                activeMenuLocation.startsWith(item.link) ||
                (item.name?.toLowerCase() === "home" &&
                  location.pathname === "/")
                  ? " font-semibold text-[#FE7701]"
                  : ""
              }`}
              to={item.link}
              onClick={() => {
                setActiveMenuLocation(item.link);
              }}
              key={index}
            >
              <div>{item.name}</div>
            </Link>
          ))}

          <div className="flex items-center gap-x-6 ml-6 mr-6">
            <div
              className="cursor-pointer"
              onClick={() => handleChangeSidebar(1)}
            >
              <div className="header-profile-container">
                <div className="header-profile-column">
                  <div className="header-profile-button rowspan">
                    <img
                      loading="lazy"
                      src={`${profileDetails?.image}`}
                      alt="profile"
                      height={"50px"}
                      width={"50px"}
                      className="header-user-profile w-10 h-10"
                    />
                  </div>
                </div>
                <div className="header-profile-column flex flex-col align-middle justify-center">
                  <span className="header-user-name mb-0 text-base font-medium text-capitalize">
                    {profileDetails?.name}
                  </span>
                  <span className="header-user-trf text-[11px]">
                    {/* {" 18:6 Prolonged TRF"} */}
                  </span>
                </div>
              </div>
            </div>

            <div className="cursor-pointer">
              <div
                className="header-profile-column"
                onClick={() => handleChangeSidebar(3)}
              >
                <img
                  loading="lazy"
                  src={fullURL + "/imageV2/4-dot-menu-icon.png"}
                  alt="profile"
                  height={"32px"}
                  width={"32px"}
                  className="header-user-profile w-6"
                />
              </div>
            </div>
            <div className="cursor-pointer">
              <div
                className="header-profile-column absolute top-[27px]"
                onClick={() => handleChangeSidebar(4)}
              >
                <img
                  loading="lazy"
                  src={fullURL + "/imageV2/bell-icon.png"}
                  alt="profile"
                  height={"32px"}
                  width={"32px"}
                  className="header-user-profile w-6"
                />
                <span className="bell-badge w-4 h-4 text-[10px]">
                  {total_notification}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Menu mobile only */}
        <div className="md:hidden gap-x-4">
          <div className="flex items-center gap-x-10 ml-6 mr-6">
            <div className="cursor-pointer">
              <div
                className="header-profile-column absolute top-[27px]"
                onClick={() => handleChangeSidebar(4)}
              >
                <img
                  loading="lazy"
                  src={fullURL + "/imageV2/bell-icon.png"}
                  alt="profile"
                  height={"32px"}
                  width={"32px"}
                  className="header-user-profile w-6"
                />
                <span className="bell-badge w-4 h-4 text-[10px]">
                  {total_notification}
                </span>
              </div>
            </div>
            <div className="cursor-pointer">
              <div
                className="header-profile-column absolute top-[27px]"
                onClick={() => handleChangeSidebar(5)}
              >
                <img
                  loading="lazy"
                  src={fullURL + "/imageV2/4-dot-menu-icon.png"}
                  alt="profile"
                  height={"32px"}
                  width={"32px"}
                  className="header-user-profile w-6"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
